<loan-update-conflict-notification></loan-update-conflict-notification>

<side-nav
  [currentlyLoggedInUser]="currentlyLoggedInUser"
  [currentCompanyGuid]="currentCompanyGuid">
</side-nav>
<header [user]="user"
  (mentionsClicked)="onMentionsStreamToggled($event)"
  (niceInContactClicked)="onNiceInContactToggled($event)"
  (notificationsClicked)="onNotificationsToggled($event)"
  (alertsCreated)="onAlertsCreated($event)"
  (conversationsToggled)="onConversationsToggled($event)"
[unreadConversations]="checkUnreadConversations()"></header>
<right-nav></right-nav>
<right-sub-nav></right-sub-nav>

<div class="container-fluid dashboard-wrapper" id="dashboard-wrapper">
  <router-outlet class="mt-5"></router-outlet>
</div>

<!-- <lead-route-leads></lead-route-leads> -->

<drawer [title]="'Mentions (' + numberOfLoadedMentions + ')'"
  #mentions
  [name]="'mentionsDrawer_NextGen'"
  [templateRef]="mentionsDrawerContentRef"
  [options]="mentionsDrawerOptions"
  (closed)="onMentionsDrawerClosed()">
</drawer>
<ng-template #mentionsDrawerContentRef>
  <mentions-stream
    (mentionClicked)="onMentionClicked($event)"
    (recordsLoaded)="onMentionsLoaded($event)">
  </mentions-stream>
</ng-template>

<drawer [title]="'Alerts & Notifications'"
  #alerts
  [name]="'alertsDrawer_NextGen'"
  [templateRef]="alertsDrawerContentRef"
  [options]="mentionsDrawerOptions"
  (closed)="onNotificationsDrawerClosed()">
</drawer>
<ng-template #alertsDrawerContentRef>
  <notifications-list
    [data]="notifications">
  </notifications-list>
</ng-template>

<drawer [title]="'Loan Activity'"
  [options]="loanActivityDrawerOptions"
  [name]="'loanActivityDrawer_NextGen'"
  [templateRef]="loanActivityRef"
  (closed)="onMentionDetailsDrawerClosed()">
</drawer>
<ng-template #loanActivityRef>
  <div style="height: 100%; padding: 12px 0 12px 12px;">
    @if (mentionMessageScope == 'InternalMessage') {
      <loan-activity
        [isSendingWhenHitEnterConfigurable]="false"
        [showOnlyActivityLog]="true"
        [idOfMessageToScrollTo]="messageId"
        [showFilters]="false"
        [activityTab]="'InternalMessage'"
        [appId]="mentionApplicationId"
        [sendWhenHitEnter]="true"
        >
      </loan-activity>
    }
  </div>
</ng-template>

<drawer [title]="'Editing Task'"
  [options]="taskEditorDrawerOptions"
  [name]="'taskEditorDrawer_NextGen'"
  [templateRef]="taskEditorRef"
  (closed)="onMentionDetailsDrawerClosed()">
</drawer>
<ng-template #taskEditorRef>
  @if (taskMentionTrackingUrl) {
    <img [src]="taskMentionTrackingUrl" class="tracker-image" width="1" height="1">
  }
  @if (mentionMessageScope == 'TaskNote' && mentionLoanDocTask) {
    <task-editor style="height: 90%"
      [hostedInModal]="false"
      [task]="mentionLoanDocTask">
    </task-editor>
  }
</ng-template>


